// https://stackoverflow.com/a/901144
import addMinutes from 'date-fns/addMinutes';
import subMinutes from 'date-fns/subMinutes';


export function getUrlParam(paramName) {
  const { href } = document.location;
  const paramNameCopy = paramName.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${paramNameCopy}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(href);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const maxInt = Number.MAX_SAFE_INTEGER;

export function toUTC(date) {
  return date.toISOString().replace('T', ' ').substr(0, 19);
}

export { maxInt };

export default {
  maxInt,
  getUrlParam,
};
